import inject from '@/util/inject';

export default {
  data() {
    return {
      isOnline: inject.get('offlineModeService').getStatus(),
      realOnline: window.navigator.onLine,
    };
  },
  methods: {
    onOfflineStatusChange(online) {
      this.isOnline = online;
    },
  },
  mounted() {
    inject.get('offlineModeService').getEventBus().$on('online-status', this.onOfflineStatusChange);

    window.addEventListener('online', () => this.realOnline = true);
    window.addEventListener('offline', () => this.realOnline = false);
  },
  beforeDestroy() {
    inject.get('offlineModeService').getEventBus().$off('online-status', this.onOfflineStatusChange);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/offline-check.js